import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import {
  InsertDraftsResponseSchema,
  InsertDraftsResponseType,
} from '../../../edit-session/schema/EditSessionSchema';
import { SampleEditSessionUrl } from '../SampleEditSessionUrl';

interface InsertSampleDraftRequest {
  sessionId: string;
  payloads: unknown[];
}

const insertSampleDraft = async ({
  sessionId,
  payloads,
}: InsertSampleDraftRequest): Promise<InsertDraftsResponseType> =>
  apiClient
    .patch(expand(SampleEditSessionUrl.rows, { sessionId }), {
      drafts: payloads.map((payload) => {
        const payloadWithSubject = payload as any;
        return {
          op: 'INSERT',
          payload: {
            ...payloadWithSubject,
            dataSubjectId: payloadWithSubject.dataSubject.id,
          },
        };
      }),
    })
    .then((response) => response.data)
    .then(InsertDraftsResponseSchema.parse);

export const useInsertSampleDraftMutation = createApiMutationHook<
  InsertSampleDraftRequest,
  InsertDraftsResponseType
>(['sample-draft-insert'], insertSampleDraft);
